export default __webpack_public_path__ + "static/media/AdobeStock_281173019.e67f5370.jpg";